import React, { useEffect, useState } from "react";
import * as classes from "./flowStepMobileAccount.module.scss";
import classNames from "classnames";
import { trackEvent } from "@utils/analytics";
import { Button } from "@components/shared";
import TextLink from "@components/atoms/TextLink";
import macBookImg from "@images/flows/mobile/macbook.png";
import { IconSuccess } from "@components/icons/iconSuccess";

export default function FlowStepMobileAccount() {
  const [isAndroid, setIsAndroid] = useState(false);
  const [isIos, setIsIos] = useState(false);

  useEffect(() => {
    // Check for Android useragent to offer appropriate app store url
    setIsAndroid(/Android/i.test(navigator.userAgent));
    setIsIos(/iPhone|iPad|iPod/i.test(navigator.userAgent));
  }, [isAndroid]);

  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        <span className={classes.checkmark}>
          <IconSuccess />
        </span>

        <h3 className="h3">Account created</h3>
        <p className={classNames(classes.subtitle, "p2")}>
          For the best experience we suggest you <strong>log in on a desktop computer</strong>
        </p>
        <div className={classes.imageWrapper}>
          <img src={macBookImg} alt="Macbook" />
        </div>
        <p className={classes.links}>
          {isAndroid || isIos ? (
            <Button
              animated
              isExternal
              variant="link"
              onClick={() => trackEvent(isAndroid ? "Download Android App" : "Download iOS App")}
              linkTo={
                isAndroid
                  ? "https://play.google.com/store/apps/details?id=com.mangomint.mangomint"
                  : "https://apps.apple.com/us/app/mangomint/id1245611301"
              }
            >
              Or download the mobile app{" "}
              <svg xmlns="http://www.w3.org/2000/svg" width="11" height="9" viewBox="0 0 11 9" fill="none">
                <path
                  d="M7 7.5L10 4.5L7 1.5"
                  stroke="#BC269B"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10 4.5L1 4.5"
                  stroke="#BC269B"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </Button>
          ) : (
            <>
              Or download the
              <TextLink
                onClick={() => trackEvent("Download iOS App")}
                to={"https://apps.apple.com/us/app/mangomint/id1245611301"}
              >
                iOS
              </TextLink>
              or
              <TextLink
                onClick={() => trackEvent("Download Android App")}
                to={"https://play.google.com/store/apps/details?id=com.mangomint.mangomint"}
              >
                Android
              </TextLink>
              app
            </>
          )}
        </p>
      </div>
    </div>
  );
}

export function Head() {
  return (
    <>
      <meta name="apple-itunes-app" content="app-id=1245611301" />
    </>
  );
}
